import React from 'react';

import styled from '@emotion/styled';

import CautionIcon from '../Icons/CautionIcon';

interface NotificationBannerProps {
  message: string;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({ message }) => {
  return (
    <Container>
      <CautionIcon />
      {message}
    </Container>
  );
};

export default NotificationBanner;

const Container = styled.div`
  display: flex;
  padding: 6px;
  padding-left: 16px;
  gap: 16px;
  background-color: rgba(255, 5, 0, 0.05);
  border: 1px solid rgba(255, 5, 0, 0.3);
  border-radius: 4px;
  font-weight: 500;

  color: #464646;
  font-size: 14px;

  & > svg {
    color: red;
    margin-top: 3px;
  }
`;
